<template>
  <div class="mt-3">
    <tnm-stage-selector :branchId.sync="branchId"> </tnm-stage-selector>

    <div class="row">
      <div
        v-if="branchId !== null"
        class="col-xl-12 col-lg-8 col-md-8 col-sm-12 col-12 mb-4 mt-2"
      >
        <app-tool-selector
          :branchId="branchId"
          :toolId="toolId"
          :toolOpinion="toolOpinion"
          v-model="toolId"
        />
      </div>
    </div>

    <!--QUESTIONS  -->
    <div v-if="toolId !== null && toolOpinion !== null" class="row">
      <div class="col">
        <h4 class="">
          Prerequisite to be eligible for selected treatment
        </h4>
      </div>
    </div>

    <div v-if="toolId !== null && toolOpinion !== null" class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3 mb-5">
        <!--Treatment History -->
        <div>
          <h5>Conditions</h5>

          <div class="mb2">
            <strong>Non Re-challenge Scenario</strong>
          </div>
          <div class="form-group row">
            <label class="col-6">Treatment can be given in which lines?</label>

            <div class="col-6">
              <v-select
                id="canBeGivenLines"
                :options="availableLines"
                label="Text"
                code="Line"
                multiple
                placeholder="Select Line(s)"
                v-model="mustBeGivenInLines"
              >
              </v-select>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-6">Must not be given after</label>

            <div class="col-6">
              <div
                v-for="(treatment, index) in mustNotBeGivenAfter"
                class="mb-2"
              >
                <v-select
                  :options="allTreatments"
                  label="name"
                  code="id"
                  placeholder="Select Treatment"
                  :value="treatment"
                  @input="value => selectTreatment(value, treatment, index)"
                >
                </v-select>
              </div>

              <div class="mt-2">
                <span
                  class="link"
                  v-on:click="addTreatment"
                  :class="!canAddNewTreat ? 'disable-link' : ''"
                  >+Add Treatment</span
                >
              </div>
            </div>
          </div>

          <div class="mb2">
            <strong>Re-challenge Scenario</strong>
          </div>
          <div class="form-group row">
            <label class="col-6">Was well tolerated</label>

            <div class="col-6 form-group history-line--tolerated mb-0">
              <div class="mr-2  text-right">
                <app-button-toggle
                  :expected="toolOpinion.hasToBeTolerated"
                  hide-ignore="true"
                  v-model="toolOpinion.hasToBeTolerated"
                />
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-6"
              >Re-challenge possible after how many treatment lines in
              between?</label
            >

            <div class="col-6">
              <v-select
                id="reChallengePossibleAfter"
                :options="availableLines"
                label="Text"
                code="Line"
                v-model="reChallengePossibleAfter"
                placeholder="Select Line"
              >
              </v-select>
            </div>
          </div>
        </div>
        <!--//Treatment History -->

        <!--Disease Status -->
        <app-group
          v-for="(group, index) of toolOpinion.groups"
          :key="index"
          :group="group"
        />
        <!--//Disease Status -->

        <!--2D Matrix -->
        <div class="mb-4">
          <h5>Compound Rating</h5>
          <app-scatter-chart
            :pointsCollection="toolOpinion.getOtherRatingsPointsCollection()"
            :point="toolOpinion.getRatingPoint()"
            :xAxisLabel="efficacyLabel"
            :yAxisLabel="safetyLabel"
            @pointCoordsChanged="pointCoordsChangedHandler"
          />
        </div>
        <!--//2D Matrix -->

        <app-submit-button
          :btnClass="'d-block mx-auto px-5'"
          :submitAction="submitToolOpinion"
          :caption="'Submit'"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import AppToolSelector from "@/components/AppToolSelector.vue";
import AppGroup from "@/components/expert/AppGroup.vue";
import { HttpHandler } from "@/http/HttpHandler";
import AppCompoundRating from "@/components/expert/AppCompoundRating.vue";
import { ToolOpinion } from "@/entities/ToolOpinion";
import AppSubmitButton from "@/components/AppSubmitButton.vue";
import AppDiseaseTreeSelector from "@/components/AppDiseaseTreeSelector.vue";
import AppScatterChart from "@/components/expert/AppScatterChart.vue";
import AppButtonToggle from "@/components/expert/AppButtonToggle.vue";
import { Treatment } from "@/entities/Treatment";
import TnmStageSelector from "@/components/TnmStageSelector.vue";
import store from "@/store/index";

@Component({
  components: {
    AppDiseaseTreeSelector,
    AppGroup,
    AppToolSelector,
    AppCompoundRating,
    AppScatterChart,
    AppSubmitButton,
    AppButtonToggle,
    TnmStageSelector
  }
})
export default class EditToolTnm extends Vue {
  private branchId: number | null = null;
  private toolId: number | null = null;
  private toolOpinion: ToolOpinion | null = null;

  mustBeGivenInLines: { Line: number; Text: string }[] = [];
  reChallengePossibleAfter: { Line: number; Text: string } | null = null;
  mustNotBeGivenAfter: Treatment[] = [];
  allTreatments: Treatment[] = [];

  setConditionProperties() {
    this.mustBeGivenInLines = this.availableLines.filter(lineInfo => {
      let savedLine = this.toolOpinion?.mustBeGivenIn?.find(
        savedLine => savedLine === lineInfo.Line
      );

      if (savedLine !== undefined) {
        return lineInfo;
      }
    });

    this.reChallengePossibleAfter = null;
    let reChallengePossibleAfter = this.availableLines.filter(lineInfo => {
      let savedLine =
        this.toolOpinion?.rechallengePossibleAfter === lineInfo.Line;
      if (savedLine) {
        return lineInfo;
      }
    });

    if (reChallengePossibleAfter.length) {
      this.reChallengePossibleAfter = reChallengePossibleAfter[0];
    }

    if (this.toolOpinion && this.toolOpinion.mustNotBeGivenAfter?.length) {
      this.toolOpinion.mustNotBeGivenAfter.forEach(treatId => {
        let existing = this.allTreatments.find(
          (t: Treatment) => t.id === treatId
        );
        if (existing) {
          this.mustNotBeGivenAfter.push(existing);
        }
      });
    } else {
      this.mustNotBeGivenAfter = [];
    }
  }

  addTreatment() {
    if (this.canAddNewTreat) {
      this.mustNotBeGivenAfter.push({
        id: 0,
        name: "Select Treatment",
        ignoreTool: false
      });
    }
  }

  selectTreatment(value: Treatment, treatment: Treatment, index: number) {
    if (!value) {
      this.mustNotBeGivenAfter.splice(index, 1);
    } else {
      treatment.id = value.id;
      treatment.name = value.name;
    }
  }

  get canAddNewTreat() {
    return !this.mustNotBeGivenAfter.find(treat => treat.id === 0);
  }

  get efficacyLabel(): string {
    return "Efficacy";
  }

  get safetyLabel(): string {
    return "Safety";
  }

  get availableLines() {
    return [
      {
        Line: 1,
        Text: "L1"
      },
      {
        Line: 2,
        Text: "L2"
      },
      {
        Line: 3,
        Text: "L3"
      },
      {
        Line: 4,
        Text: "L4"
      },
      {
        Line: 5,
        Text: "L5"
      }
    ];
  }

  @Watch("branchId")
  async onBranchChanged(newBranchId: number) {
    console.log('onBranchChanged', newBranchId);
    this.toolOpinion = null;
    if (!newBranchId) {
      this.toolId = null;
    } else {
      await this.getToolOpinion(newBranchId, this.toolId);
    }

    await this.replaceQueryParams();
  }

  @Watch("toolId")
  async onToolChanged(newToolId: number) {
    await this.getToolOpinion(this.branchId, newToolId);
    await this.replaceQueryParams();
  }

  async getTool(branchId: number, toolId: number) {
    let httpHandler = new HttpHandler(store);
    this.toolOpinion = await httpHandler.getToolOpinionByBranchIdAndToolId(
      branchId,
      toolId
    );
    if (this.toolOpinion) {
      const tool = this.$store.getters["tool/getToolById"](toolId);

      this.toolOpinion.name = tool?.name ?? "";

      this.setConditionProperties();
    }

    this.allTreatments = this.$store.getters["tool/getAllTools"];
    this.toolId = toolId;
    this.branchId = branchId;
  }

  async replaceQueryParams(): Promise<void> {
    const branchIdEquals = (this.$route.query.branchId || '') === (this.branchId?.toString() || '');
    const toolIdEquals = (this.$route.query.toolId || '') === (this.toolId?.toString() || '');

    if (branchIdEquals && toolIdEquals) return;

    let query = {};
    if (this.branchId) {
      Object.assign(query, { branchId: this.branchId.toString() });
    }

    if (this.toolId) {
      Object.assign(query, { toolId: this.toolId.toString() });
    }

    await this.$router.replace({ name: "Edit treatment TNM", query: query });
  }

  async getToolOpinion(branchId: number | null, toolId: number | null) {
    let httpHandler = new HttpHandler(store);
    this.toolOpinion = await httpHandler.getToolOpinionByBranchIdAndToolId(
      branchId,
      toolId
    );
    if (this.toolOpinion) {
      const tool = this.$store.getters["tool/getToolById"](toolId);

      this.toolOpinion.name = tool?.name ?? "";

      this.setConditionProperties();
    }

    this.allTreatments = this.$store.getters["tool/getAllTools"];
  }

  pointCoordsChangedHandler(coord: [number, number]) {
    const efficacy = coord[0];
    const safety = coord[1];

    if (this.toolOpinion) {
      this.toolOpinion.setSafety(safety);
      this.toolOpinion.setEfficacy(efficacy);
    }
  }

  async submitToolOpinion() {
    let httpHandler = new HttpHandler(store);

    if (this.toolOpinion != null) {
      this.toolOpinion.mustBeGivenIn = this.mustBeGivenInLines.map(
        lineInfo => lineInfo.Line
      );
      this.toolOpinion.rechallengePossibleAfter = this.reChallengePossibleAfter?.Line;
      this.toolOpinion.mustNotBeGivenAfter = this.mustNotBeGivenAfter
        .filter(treat => treat.id !== 0)
        .map(treat => treat.id);

      await httpHandler.postToolOpinionByBranchIdAndToolId(
        this.branchId,
        this.toolId,
        this.toolOpinion
      );
    }
  }

  async created() {}

  async getResult(id: string) {
    let httpHandler = new HttpHandler(store);
    return await httpHandler.getTypeTree(id);
  }
}
</script>

<style scoped lang="scss">
@import "node_modules/bootstrap/scss/_functions.scss";
@import "node_modules/bootstrap/scss/_variables.scss";
@import "node_modules/bootstrap/scss/_mixins.scss";

.scrolled {
  overflow-y: scroll;
  height: calc(100vh - 180px);
  overflow-x: hidden;

  @include media-breakpoint-down(xs) {
    height: calc(100vh - 80px);
  }
}

.link {
  color: #007bff;
  cursor: pointer;
}

.disable-link {
  color: grey;
  cursor: unset;
}
</style>
